module.exports = new __parcel__URL__("DOT.7e599be5.svg").toString();